// extracted by mini-css-extract-plugin
module.exports = {"text":"accessDenied_text_1UD7B"};